import { fromJS } from "immutable";
import * as types from "../constants";

const defaultState = fromJS({
  status: false,
  title_section: "What Our Customers Say",
  title_section_color: "#000000",
  background_color_section: "#ffffff",
  background_color_card: "#ffffff",
  color_primary: "#848484",
  color_secondary: "#60B6FF",
  author_status: true,
  author_color: "#76AFFD",
  email_status: true,
  email_color: "#757575",
  style_section: "default",
  list_review_id: [],
  list_customer_say_result: {},
  listReview: [],
});

let data;

const customerSayReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CHANGE_SETTINGS_CUSTOMER_SAY:
      data = action.payload;
      return state.set(data.field, data.value);

    case types.CHANGE_STATUS_CUSTOMER_SAY_RESULT:
      data = action.payload;
      return state.set("status", data);

    case types.GET_LIST_REVIEW_CUSTOMER_SAY_RESULT:
      return state.set(
        "listReview",
        action.payload?.list_product_reviews || [],
      );

    case types.GET_LIST_CUSTOMER_SAY_BY_ID_RESULT:
      data = {};
      (action.payload || []).forEach((value) => {
        data[value.id] = value;
      });
      return state.set("list_customer_say_result", fromJS(data));

    case types.GET_SETTINGS_CUSTOMER_SAY_RESULT:
      data = action.payload;
      return state
        .set("status", data.customer_say_status)
        .set("list_review_id", fromJS(data.list_review_id))
        .set("title_section", data.title_section)
        .set("title_section_color", data.title_section_color)
        .set("background_color_section", data.background_color_section)
        .set("background_color_card", data.background_color_card)
        .set("color_primary", data.color_primary)
        .set("color_secondary", data.color_secondary)
        .set("author_status", data.author_status)
        .set("author_color", data.author_color)
        .set("email_status", data.email_status)
        .set("email_color", data.email_color)
        .set("style_section", data.style_section);

    case types.RESET_CUSTOMER_SAY_SETTINGS_RESULT:
      data = action.payload;
      return state
        .set("list_review_id", fromJS(data.list_review_id))
        .set("title_section", data.title_section)
        .set("title_section_color", data.title_section_color)
        .set("background_color_section", data.background_color_section)
        .set("background_color_card", data.background_color_card)
        .set("color_primary", data.color_primary)
        .set("color_secondary", data.color_secondary)
        .set("author_status", data.author_status)
        .set("author_color", data.author_color)
        .set("email_status", data.email_status)
        .set("email_color", data.email_color)
        .set("style_section", data.style_section);
    default:
      return state;
  }
};

export default customerSayReducer;
